import { createSelector } from 'reselect'
import { Map, OrderedSet } from 'immutable'
import i18next from 'i18next'
import { STORIES_PROTRACK_FILTER_DEFAULT_ID, STORIES_PROTRACK_FILTER_DEFAULT_VALUE } from 'app/constants/stories'

export const getStories = state => state.get('stories')

export const getStoriesList = createSelector(getStories, state => state.get('stories'))

export const getStoriesPagination = createSelector(getStories, state => state.get('storiesPagination'))

export const getStoriesProTrackId = createSelector(getStories, state => state.get('proTrackId'))

export const getStoriesProTrackList = createSelector(getStories, state => state.get('proTracks'))
export const getStoriesProTrackOptions = createSelector(getStoriesProTrackList, list => {
  const filter = list.slice().reduce(
    (acc, activity) => {
      const id = activity.get('proTrackId')
      return {
        ids: acc.ids.add(id),
        map: acc.map.set(id, `${activity.get('publicProTrackName')} (${activity.get('levelName')})`),
      }
    },
    {
      ids: OrderedSet([STORIES_PROTRACK_FILTER_DEFAULT_ID]),
      map: Map({
        [STORIES_PROTRACK_FILTER_DEFAULT_ID]: i18next.t(STORIES_PROTRACK_FILTER_DEFAULT_VALUE),
      }),
    }
  )
  return Map(filter)
})

export const getStoriesPending = createSelector(getStories, state => state.getIn(['pending', 'getStories']))
export const getStoriesLoadMorePending = createSelector(getStories, state =>
  state.getIn(['pending', 'getStoriesLoadMore'])
)

export const getStoriesLoadMoreLoaded = createSelector(getStories, state =>
  state.getIn(['loaded', 'getStoriesLoadMore'])
)
